import React from 'react';
import Card from 'components/Card/Card';
import { EditImage } from 'components/EditImage/EditImage';
import { EditText, EditTextArea, EditDropDown } from 'components/EditText/EditText';
import RoutesBar from 'components/SwitchBar/SwitchBar';
import religion from '../../../../lib/religions';

const WorshipLocationItem = ({ editing, worship, onEdit, onToggle }) => {
    const getOptions = () => {
        console.warn('getOptions:');
        const options = [...religion];
        options.unshift({ id: 'select', name: 'Select' });

        return options;
    };

    return (
        <Card title="Worship Location Information" editing={editing ? '1' : undefined} onToggle={onToggle}>
            <div className="group-edit-outer">
                <div className="group-edit-image-outer me-4">
                    <EditImage
                        editing={editing ? '1' : undefined}
                        imageid={worship.image_id}
                        onChange={(imageId) => onEdit({ image_id: imageId })}
                    />
                </div>
                <div className="group-edit-text-outer">
                    <RoutesBar
                        className="mb-4"
                        editing={editing ? '1' : undefined}
                        options={['Active', 'Archived']}
                        values={[1, 0]}
                        value={worship.active}
                        onChange={(value) => onEdit({ active: value })}
                    />
                    <EditText
                        label="Title"
                        editing={editing ? '1' : undefined}
                        onChange={(text) => onEdit({ title: text })}
                        value={worship.title}
                    />
                    <EditTextArea
                        label="Description"
                        editing={editing ? '1' : undefined}
                        onChange={(text) => onEdit({ description: text })}
                        value={worship.description}
                    />
                    <EditText
                        label="Location"
                        editing={editing ? '1' : undefined}
                        onChange={(text) => onEdit({ location: text })}
                        value={worship.location}
                    />
                    <EditText
                        outerClassName="mb-3 mt-2"
                        label="Email address"
                        editing={editing ? '1' : undefined}
                        onChange={(text) => onEdit({ email_address: text })}
                        value={worship.email_address}
                    />
                    <EditText
                        outerClassName="mb-3 mt-2"
                        label="Phone"
                        editing={editing ? '1' : undefined}
                        onChange={(text) => onEdit({ phone: text })}
                        value={worship.phone}
                    />
                    <EditDropDown
                        className="mb-3"
                        label="Religion"
                        options={getOptions()}
                        editing={editing ? '1' : undefined}
                        onChange={(id) => {
                            console.warn('Religion:', id);
                            const data = religion.filter((item) => item.id === id);
                            const value = data.length ? data[0].id : '';

                            onEdit({ religion: value });
                        }}
                        value={worship.religion}
                    />
                    <EditTextArea
                        label="Details"
                        editing={editing ? '1' : undefined}
                        onChange={(text) => onEdit({ details: text })}
                        value={worship.details}
                    />
                </div>
            </div>
        </Card>
    );
};

export default WorshipLocationItem;
